<template>
  <v-container class="d-flex align-center justify-center" fluid>
    <v-row v-if="insights === undefined || typeof insights !== 'object'">
      <h3 class="text-center my-7">Loading...</h3>
    </v-row>
    <v-row align="center" justify="center" v-if="insights.brokerAccountInsights && insights.brokerAccountInsights.length > 0">
      <v-col v-bind:key="`${insight.insightType}${insight.id}`" v-for="insight in insights.brokerAccountInsights" cols="3">
        <v-card class="d-flex align-center justify-center pa-7 insight-card" :style="`border-color: ${getInsightColor(insight)}!important;`" outlined>
          <div>
            <div class="d-flex justify-center" style="cursor: pointer" @click="insightDetails(insight)">
              <v-img class="mb-3" position="center center" :src="getInsightImage(insight)" :max-width="(full)? '42px' : '55px'" :max-height="(full)? '42px' : '55px'" contain/>
            </div>
            <h3 class="text-center" v-html="getInsightValue(insight)" style="cursor: pointer" @click="insightDetails(insight)"/>
            <p class="text-center mt-2 mb-5" v-html="getInsightSubtitle(insight)"/>
            <div v-if="full" class="d-flex align-center justify-center">
              <v-switch class="mt-1 mb-n5" :label="`${$t('notifyPrepend')} ${capitalize(getInsightTitle(insight))}`" @change="modifyState(insight)" v-model="insight.active" inset/>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row :style="(full)? 'height: 70vh' : ''" align="center" justify="center" v-else>
      <div>
        <v-icon class="d-flex align-center justify-center my-5" x-large>fa-regular fa-grin-beam-sweat</v-icon>
        <h2 class="text-center">{{ $t('notEnough.title') }}</h2>
        <p class="text-center mb-0">{{ $t('notEnough.subtitle') }}</p>
      </div>
    </v-row>
    <v-overlay :dark="false" v-model="overlayInsightDetails">
      <InsightDetails @closeWindow="overlayInsightDetails = false" :insight="currentInsight"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/insights';
import InsightDetails from "@/views/Mentor/components/InsightDetails";
import InsightsData from '../insightsData';
export default {
  name: "InsightsSummary",
  components: {InsightDetails},
  props: {
    insights: Object,
    full: Boolean,
  },
  data() {
    return {
      insightsType: [
        'WINNING_STREAK',
        'LOSING_STREAK',
        'MOST_FREQUENT_TRADE_CLOSING_TIME',
        'MILESTONE_TRADE',
        'BEST_NET_PROFIT',
        'PERFORMANCE_BY_MOODS',
        'CONSECUTIVE_SIDE',
        'MONETARY_RISK_EXCEEDED',
        'PERFORMANCE_BY_STRATEGIES',
        'BEST_TRADE_RISK_REWARD',
        'PERFORMANCE_BY_DAYS',
        'PERFORMANCE_BY_STRATEGY_AND_ASSET',
        'CONSISTENCY_RULE',
      ],
      overlayInsightDetails: false,
      currentInsight: null,
    };
  },
  watch: {
    insights() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  computed: {
  },
  methods: {
    init() {

    },
    modifyState(insight) {
      let newInsightState = {
        id: insight.id,
        insightType: insight.insightType,
        newActiveState: insight.active,
      };

      Repository.modifyInsightState(newInsightState).then((response) => {
        if(response.status < 400)
          alert(this.$t('notifyChange'));
      });
    },
    insightDetails(insightAux) {
      // eslint-disable-next-line no-console
      let insight = insightAux;
      //let insightFound = InsightsData.find((insightMaster) => insightMaster.insightType === insight.insightType);
      //alert(`${this.capitalize(insightFound.insightType)} 💡\n${insightFound.description}`);
      this.currentInsight = InsightsData.find((insightMaster) => insightMaster.insightType === insight.insightType);
      this.overlayInsightDetails = true;
    },
    getInsightColor(insight) {
      return InsightsData.find((insightMaster) => insightMaster.insightType === insight.insightType).color;
    },
    getInsightTitle(insight) {
      let insightFound = InsightsData.find((insightMaster) => insightMaster.insightType === insight.insightType);
      // If no language-specific name is found, fall back to English
      return insightFound.insightType;
    },
    getInsightSubtitle(insight) {
      let insightFound = InsightsData.find((insightMaster) => insightMaster.insightType === insight.insightType);
      const locale = this.$i18n.locale;
      
      // Try to get subtitle for the current locale
      const subtitleKey = `subtitle${locale.toUpperCase()}`;
      
      // Return subtitle for current language if available, or fall back to English
      if (insightFound[subtitleKey]) {
        return insightFound[subtitleKey];
      } else if (locale === "es" && insightFound.subtitleES) {
        return insightFound.subtitleES;
      } else {
        return insightFound.subtitleEN;
      }
    },
    getInsightImage(insight) {
      return InsightsData.find((insightMaster) => insightMaster.insightType === insight.insightType).imageUrl;
    },
    getInsightValue(insight) {
      let insightType = insight.insightType;
      if (insightType === 'CONSECUTIVE_SIDE')
        return (insight.consecutiveLongs > 0) ? `${insight.consecutiveLongs} ${this.$t('values.consecutiveLong')}` : `${insight.consecutiveShorts} ${this.$t('values.consecutiveShort')}`;
      if (insightType === 'BEST_NET_PROFIT')
        return `${this.getNumber(insight.bestNetProfit)}`;
      if (insightType === 'BEST_TRADE_RISK_REWARD')
        return `1 : ${(insight.netProfit / insight.monetaryRisk).toFixed(2)}`;
      if (insightType === 'CONSISTENCY_RULE')
        return `${this.getNumber(insight.netProfitSumOverPeriod)}`;
      if (insightType === 'LOSING_STREAK')
        return `${insight.consecutiveTradesWithNegativeNetProfit} trades`;
      if (insightType === 'WINNING_STREAK')
        return `${insight.bestStreakEver} trades`;
      if (insightType === 'MILESTONE_TRADE')
        return `${insight.totalNumberOfTrades} trades`;
      if (insightType === 'MONETARY_RISK_EXCEEDED') {
        let riskSum = 0, count = insight.latestMonetaryRisks.length;
        insight.latestMonetaryRisks.forEach((risk) => riskSum += risk);
        return `${(count > 0)? (riskSum/count).toFixed(2) : 0} ${this.$t('values.monetaryRisk')}`;
      }
      if (insightType === 'MOST_FREQUENT_TRADE_CLOSING_TIME') {
        let minRange = this.convertSecondsToTime(insight.highDensityPositiveRanges[0].minVal);
        let maxRange = this.convertSecondsToTime(insight.highDensityPositiveRanges[0].maxVal);
        return `${minRange} ${this.$t('values.to')} ${maxRange}`;
      }
      if (insightType === 'PERFORMANCE_BY_DAYS') {
        let daysInfo = [...insight.daysInfo];
        daysInfo.sort((dayA, dayB) => dayB.wins - dayA.wins);
        return `${this.capitalize(insight.daysInfo[0].name)} (${insight.daysInfo[0].wins} ${this.$t('values.wins')})`;
      }
      if (insightType === 'PERFORMANCE_BY_MOODS') {
        let moodsInfo = [...insight.moodsInfo];
        moodsInfo.sort((moodA, moodB) => moodB.wins - moodA.wins);
        return `${this.capitalize(insight.moodsInfo[0].name)} (${insight.moodsInfo[0].wins} ${this.$t('values.wins')})`;
      }
      if (insightType === 'PERFORMANCE_BY_STRATEGIES') {
        let strategyInfo = [...insight.strategyInfo];
        strategyInfo.sort((strA, strB) => (strB.winsLong + strB.winsShort) - (strA.winsLong + strA.winsShort));
        return `${this.capitalize(insight.strategyInfo[0].name)} (${insight.strategyInfo[0].winsLong + insight.strategyInfo[0].winsShort} ${this.$t('values.wins')})`;
      }
      if (insightType === 'PERFORMANCE_BY_STRATEGY_AND_ASSET') {
        let strategyAndAssetInfo = [...insight.strategyAndAssetInfo];
        strategyAndAssetInfo.sort((strA, strB) => strB.wins - strA.wins);
        return `${this.capitalize(insight.strategyAndAssetInfo[0].name)} (${insight.strategyAndAssetInfo[0].wins} ${this.$t('values.wins')})`;
      }
      return `Value`;
    },
    getNumber(number) {
      return (number > 1000 || number < -1000)? `${(number/1000).toFixed(2)}k` : (number.toFixed(2) * 1).toString();
    },
    capitalize(string){
      string = string.toString().replaceAll('_', ' ');
      return string.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
    },
    convertSecondsToTime(seconds) {
      let hour = 0.0, minutes = 0.0;
      if(seconds / 3600.0 > 0.0) {
        hour = seconds / 3600.0;
        seconds = seconds - (Math.floor(hour) * 3600.0);
      }
      minutes = seconds/60.0;
      let utcTime = `${(Math.floor(hour) >= 10)? Math.floor(hour) : '0' + Math.floor(hour)}:${(minutes.toFixed(0) >= 10)? minutes.toFixed(0) : '0' + minutes.toFixed(0)}`
      let localDate = new Date('2020-03-11T'+utcTime+':00.000Z');
      return `${(localDate.getHours() >= 10)? localDate.getHours() : '0' + localDate.getHours()}:${(localDate.getMinutes() >= 10)? localDate.getMinutes() : '0' + localDate.getMinutes()}`
    }
  }
}
</script>



<style lang="scss" scoped>
@import "src/global";
  .insight-card {
    height: 220px !important;
    min-width: 200px !important;
    border-radius: 20px !important;
    border-color: var(--v-darkGreen-base) !important;
    background-color: rgba(0,0,0,0);

    .head {
      color: var(--v-mainBlack-base);
      font-size: 21px;
    }

    .content {
      color: $text-color;
    }
  }
</style>
